var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"date-range-container",attrs:{"align-center":"","justify-center":"","column":""}},[_vm._v("\n  "+_vm._s(_vm.calculatedText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }